import { Box, Typography } from '@mui/material';

import { CHAT_GRETTINGS } from 'src/utils/constants';

function ChatWelcome() {
  const { WELCOME_TEXT } = CHAT_GRETTINGS;

  return (
    <Box textAlign="center" sx={{ display: 'flex', flexGrow: 1, alignItems: 'center' }}>
      <Typography variant="h6" color="text.secondary">
        {WELCOME_TEXT[0]} <br /> {WELCOME_TEXT[1]}
      </Typography>
    </Box>
  );
}

export default ChatWelcome;
